import { format } from 'date-fns';
import * as Yup from 'yup';
import { DEFAULT_DATE_TIME } from '../components/common/Constants';

export function minNumber(number, t) {
    return Yup.number().min(number, t('validations:higherThan') + number)
}

export function minStringNumber(number, t) {
    return Yup.string().test('test', t('validations:higherThan') + 0, (value) => value > 0)
}

export function minStringLength(number, t) {
    return Yup.string().min(number, t('validations:minLength') + number)
}

export function minPrice(price, t) {
    return Yup.number().min(0.01, t('validations:minPrice'));
}

export function notLaterThan(date, t) {
    return Yup.date().min(date, t('validations:notLaterThan') + format(date, DEFAULT_DATE_TIME));
}